import useGetSolutionById, { QbQuestionType } from './useGetSolutionById';

export { QbQuestionType };
export default useGetSolutionById;
